import $ from 'jquery';

function NaviCtrl() {
	this.$win      = $(window);
	this.$htmlBody = $('html, body');
	this.$body     = $('body');
	this.$target   = $('#gNavi');
	this.$naviToggle  = $('#naviToggle');
	this.$content = $('#main');

	this.scrollState = 0;

	this.open  = this.open.bind(this);
	this.close = this.close.bind(this);

	this.init();
}

NaviCtrl.prototype.init = function() {
	this.$naviToggle.on('click', this.open);
	this.$target.find('a').on('click', this.close);
}

NaviCtrl.prototype.openClass = function () {
  this.$htmlBody.addClass('opened');
  this.$target.addClass('opened');
  this.$naviToggle.addClass('opened');
}
NaviCtrl.prototype.closeClass = function () {
  this.$htmlBody.removeClass('opened');
  this.$target.removeClass('opened');
  this.$naviToggle.removeClass('opened');
}

NaviCtrl.prototype.open = function() {
	if (! this.$target.hasClass('opened')) {
		// let scrollTop = this.$win.scrollTop();
		// scrollCache = scrollTop;
		// this.scrollState = scrollTop;
    this.openClass();
		// this.$content.css('transform', 'translateY(-' + scrollTop + 'px)');
	} else {
    this.closeClass();
		// this.$win.scrollTop(this.scrollState);
		// this.$content.css('transform', 'translateY(0px)');
	}
}

NaviCtrl.prototype.close = function() {
  this.closeClass();

	// this.$win.scrollTop(this.scrollState);
	// this.$content.css('transform', 'translateY(0px)');
}

export default NaviCtrl;